rjm.ui.ChartBuilderCohortTimeOptionsMovingView = Backbone.View.extend
  events:
    "input div.interval input": "filterNonNumeric"
    
  initialize: (options) ->
    if not options or not options.cohortDescriptor 
      throw "InvalidConstructorArgs - ChartBuilderCohortTimeOptionsMovingView"
    
    _.bindAll this, "save", "filterNonNumeric", "generateTemplateData", "render"
    @model = options.cohortDescriptor

    return

  save: (e) ->
    @model.set 
      count: parseInt(@$('div.cohort-count input').val())
      minimumIntervals: parseInt(@$('div.min-intervals input').val())
      type: rjm.app.enums.cohortDescriptorType.MOVING
      includeCurrentPeriod: @$("#currentPeriodCheckbox").is(":checked")
    , 
      silent: true
      
    @render()
    return

  filterNonNumeric: (event) ->
    if parseInt($(event.target).val()) < 0
      $(event.target).val("")

  generateTemplateData: -> 
    timeIntervals = {}
    _(rjm.app.enums.timeInterval).each (interval, key) ->
      unless key is "SECOND"
        newInterval = {}
        newInterval.name = interval.names + "(s)"
        timeIntervals[key] = newInterval

    return (
      timeInterval: timeIntervals[@model.get('timeInterval')] 
      count: if @model.get("type") is rjm.app.enums.cohortDescriptorType.MOVING then @model.get("count") else 6
      minimumIntervals: if @model.get("type") is rjm.app.enums.cohortDescriptorType.MOVING then @model.get("minimumIntervals") else 1
      includeCurrentPeriod: @model.get("includeCurrentPeriod")
    )

  render: ->
    $(@el).html ich["chartBuilderCohortTimeOptions.moving"](@generateTemplateData())

    @$("#currentPeriod").toggleButtons
      width: 75
      height: 20
      label:
        enabled: "Yes"
        disabled: "No"
      style:
        enabled: "success"
        disabled: "danger"

    return @
